import { render, staticRenderFns } from "./SupportEndpoints.vue?vue&type=template&id=91e6340e&"
import script from "./SupportEndpoints.vue?vue&type=script&lang=js&"
export * from "./SupportEndpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports